import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { Field } from 'redux-form';

import TextInput from '../fields/TextInput';
import Heading from '../elements/PageHeading';
import Paragraph from '../elements/Paragraph';

const IdLabel = styled.div`
  margin: auto;
  margin-top: 10px;
  margin-bottom: 0px;
  color: ${props => props.theme.primary};
  font-size: 16px;
`;

const IdField = styled.div`
  margin: auto;
  margin-top: 10px;
  margin-bottom: 0px;
  color: ${props => props.theme.secondary};
  font-size: 18px;
`;

const DeviceNamePage = ({ handleSubmit, t, deviceId }) => (
  <React.Fragment>
    <Heading text={t('device_name.title')} />
    <IdLabel>{t('id')}</IdLabel>
    <IdField>
      {' '}
      {
        //Show device id so user can see that their scan was successful.
        deviceId
      }
    </IdField>
    <form onSubmit={handleSubmit}>
      <Field name="Name" type="text" component={TextInput} />
    </form>
    <Paragraph>{t('device_name.hint')}</Paragraph>
  </React.Fragment>
);

const mapStateToProps = state => ({
  deviceId: state.device.target,
});

export default connect(mapStateToProps)(translate()(DeviceNamePage));
